import { useEffect, useRef, useState } from 'react';

export default function EmpathySection() {
  const headingRef = useRef<HTMLHeadingElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (headingRef.current) {
      observer.observe(headingRef.current);
    }

    return () => {
      if (headingRef.current) {
        observer.unobserve(headingRef.current);
      }
    };
  }, []);

  return (
    <section id="empathy" className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 bg-gradient-to-br from-orange-400 via-orange-500 to-orange-600">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 sm:mb-12">
          <h2 
            ref={headingRef}
            className={`text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 sm:mb-8 leading-tight transition-all duration-1000 ease-out ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'
            }`}
          >
            歌ってみた、やってみたいけど<br />
            一歩が踏み出せないあなたへ
          </h2>
          <p className="text-white text-base sm:text-lg leading-relaxed max-w-3xl mx-auto mb-3 sm:mb-4">
            動画はずっと見ているのに、自分が歌う側にまわるのはこわい。
          </p>
          <p className="text-white text-base sm:text-lg leading-relaxed max-w-3xl mx-auto mb-6 sm:mb-8">
            そんな気持ち、よくわかります。
          </p>
        </div>

        {/* 悩みのチェックボックス */}
        <div className="max-w-3xl mx-auto space-y-3 sm:space-y-4 mb-6 sm:mb-8 flex flex-col items-center">
          <div className="bg-white rounded-lg px-4 sm:px-6 py-3 sm:py-4 flex items-center gap-3 shadow-md w-full sm:w-fit">
            <div className="w-5 h-5 border-2 border-orange-500 rounded flex items-center justify-center flex-shrink-0">
              <i className="ri-check-line text-orange-500 text-sm"></i>
            </div>
            <span className="text-gray-800 font-medium text-sm sm:text-base">
              家では声を出せない。録音する場所がない。
            </span>
          </div>

          <div className="bg-white rounded-lg px-4 sm:px-6 py-3 sm:py-4 flex items-center gap-3 shadow-md w-full sm:w-fit">
            <div className="w-5 h-5 border-2 border-orange-500 rounded flex items-center justify-center flex-shrink-0">
              <i className="ri-check-line text-orange-500 text-sm"></i>
            </div>
            <span className="text-gray-800 font-medium text-sm sm:text-base">
              録音やMIXのやり方がそもそも分からない。
            </span>
          </div>

          <div className="bg-white rounded-lg px-4 sm:px-6 py-3 sm:py-4 flex items-center gap-3 shadow-md w-full sm:w-fit">
            <div className="w-5 h-5 border-2 border-orange-500 rounded flex items-center justify-center flex-shrink-0">
              <i className="ri-check-line text-orange-500 text-sm"></i>
            </div>
            <span className="text-gray-800 font-medium text-sm sm:text-base">
              自分の歌、下手だと思われたらどうしよう。
            </span>
          </div>
        </div>

        {/* 締めの文章 */}
        <div className="text-center max-w-3xl mx-auto">
          <p className="text-white text-sm sm:text-base leading-relaxed">
            これらは、あなたの努力不足ではありません。
          </p>
          <p className="text-white text-sm sm:text-base font-bold leading-relaxed mt-2">
            歌い手としての一歩を支えてくれる「環境」と「やり方」に、出会えていなかっただけです。
          </p>
        </div>
      </div>
    </section>
  );
}
